
export type StageType = string

export const DEVELOPMENT : StageType = 'development'
export const PRODUCTION : StageType = 'production'
